<template>
    <div class="reservation">
        <div class="h-header-bottom">
            <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
                <el-menu-item index="/home/reservation/Mrliu">今日预约</el-menu-item>
            </el-menu>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
  import "../../assets/css/style1.css"; 

  export default {
    data: function () {
      return {
        activeIndex: "/home/reservation/Mrliu"
      };
    }
  };
</script>

<style scoped>
    body {
        background-color: #f6f6f6;
    }
</style>



// WEBPACK FOOTER //
// reservation.vue?76f39c62